import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import Layout from '../components/Layout';
import DealsBoard from '../components/DealsBoard';
import {api} from '../../api';


const STAGE_COLORS = {
  DISCOVERY: 'bg-purple-100 text-purple-800',
  QUALIFIED: 'bg-blue-100 text-blue-800',
  PROPOSAL: 'bg-yellow-100 text-yellow-800',
  NEGOTIATION: 'bg-orange-100 text-orange-800',
  CLOSED_WON: 'bg-green-100 text-green-800',
  CLOSED_LOST: 'bg-red-100 text-red-800',
};

export default function Deals() {
  const [deals, setDeals] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [view, setView] = useState('board');

  const load = () => api('/deals').then(r => r.json()).then(setDeals).catch(() => {});
  useEffect(() => { load(); }, []);

  const filtered = deals.filter(d => {
    const contactNames = (d.contacts || []).map(c => `${c.firstName} ${c.lastName}`).join(' ');
    return `${d.name} ${d.companyName || ''} ${contactNames}`.toLowerCase().includes(searchTerm.toLowerCase());
  });

  return (
    <Layout>
      <div className="bg-white rounded-lg shadow">
        <div className="p-4 md:p-6 border-b">
          <div className="flex justify-between items-center mb-4">
            <h1 className="text-2xl font-bold text-gray-900">Deals</h1>
            <div className="flex gap-2">
              <div className="flex border border-gray-300 rounded-lg overflow-hidden">
                <button onClick={() => setView('board')} className={`px-3 py-2 text-sm ${view === 'board' ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'}`}>Board</button>
                <button onClick={() => setView('table')} className={`px-3 py-2 text-sm ${view === 'table' ? 'bg-blue-600 text-white' : 'bg-white text-gray-700 hover:bg-gray-50'}`}>Table</button>
              </div>
              <Link to="/crm/deals/new" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
                Add Deal
              </Link>
            </div>
          </div>
          <input
            type="text"
            placeholder="Search deals by name, company, or contact..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
          />
        </div>
        {view === 'board' ? (
          <div className="p-4">
            <DealsBoard deals={filtered} onUpdate={load} />
          </div>
        ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Deal</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Company</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Value</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Stage</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Contacts</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase hidden md:table-cell">Close Date</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filtered.map((d) => (
                <tr key={d.id} className="hover:bg-gray-50">
                  <td className="px-6 py-4 whitespace-nowrap font-medium">
                    <Link to={`/crm/deals/${d.id}`} className="text-blue-600 hover:text-blue-800">{d.name}</Link>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-600 hidden md:table-cell">
                    {d.companyId ? <Link to={`/crm/companies/${d.companyId}`} className="text-blue-600 hover:text-blue-800">{d.companyName}</Link> : '—'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap font-semibold text-gray-900">{d.value != null ? `$${d.value.toLocaleString()}` : '—'}</td>
                  <td className="px-6 py-4 whitespace-nowrap">
                    <span className={`px-3 py-1 rounded-full text-sm font-medium ${STAGE_COLORS[d.stage] || 'bg-gray-100 text-gray-800'}`}>
                      {d.stage.replace(/_/g, ' ')}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-gray-600 hidden md:table-cell">
                    {d.contacts && d.contacts.length > 0
                      ? d.contacts.map((c, i) => <span key={c.id}>{i > 0 && ', '}<Link to={`/crm/contacts/${c.id}`} className="text-blue-600 hover:text-blue-800">{c.firstName} {c.lastName}</Link></span>)
                      : '—'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-gray-600 hidden md:table-cell">{d.closeDate || '—'}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {filtered.length === 0 && (
            <div className="text-center py-12 text-gray-500">No deals found.</div>
          )}
        </div>
        )}
      </div>
    </Layout>
  );
}
